import Header from "../../components/Header";
import HeroContent from "./components/HeroContent";
import Features from "./components/Features";
import Working from "./components/Working";
import FaqAccordion from "./components/FaqAccordian";
import Pricing from "./components/Pricing";
import ExamNameSlider from "./components/ExamNameSlider";
import Footer from "./components/Footer";
import Resources from "./components/Resources";
import Testimonials from "./components/Testimonials";
import CorePillars from "./components/CorePillars";
import HowZeoWorks from "./components/HowZeoWorks";
import WhoItsFor from "./components/WhoItsFor";
import CallToAction from "./components/CallToAction";
import CredibilitySection from "./components/CredibilitySection";
import InsightsSection from "./components/InsightsSection";
import FinalCTA from "./components/FinalCTA";
import FooterSection from "./components/FooterSection";

const Home = () => {
  return (
    <div id="home">
      <Header home={false} />
      <div className="px-8">
        <HeroContent />
        <CorePillars />
        <HowZeoWorks />
        <WhoItsFor />
        <CallToAction />
        <CredibilitySection />
        <InsightsSection />
        <FinalCTA />
      </div>
      <Footer />
    </div>
  );
};

export default Home;
